skrilla.controller('depositDetailsCtrl', function ($scope, searchService, $stateParams, cacheService, modalService, adminService, paymentIqService) {
    $scope.key = "depositDetails";
    $scope.hasRole = adminService.hasRole;
    const refundableProviders = ['MERCHANT_WARRIOR', 'MERCHANT_WARRIOR_APPLE_PAY', 'MERCHANT_WARRIOR_GOOGLE_PAY']

    $scope.get = function() {
        searchService.get("deposits/" + $stateParams.id).then(function(response){
            $scope.deposit = response.data;
            const txId = $scope.deposit.attributes['txId'];
            if ( $scope.deposit.provider === 'PAYMENT_IQ'  && txId )
            {
                $scope.paymentIqUrl =  paymentIqService.getTransactionUrl(txId)
            }
        });
    }
    $scope.refund = function(){
        cacheService.registerObject("depositDetails", $scope.deposit)
        modalService.openModal("views/depositDetails/refundDepositModal.html", true, 'lg', true, true, $scope.get);
    }

    $scope.refundable = function () {
        return $scope.deposit && $scope.deposit.status === 'PROCESSED' && refundableProviders.includes($scope.deposit.provider)
    }


    $scope.get();
});